import type { CSSProperties } from 'react';
import type { PastelColor } from './Pill';

type Shape = 'circle' | 'pill' | 'square';

interface C2ShapeProps {
  shape?: Shape;
  size?: number;
  color?: PastelColor | string;
  className?: string;
  style?: CSSProperties;
}

const pastelVar: Record<PastelColor, string> = {
  peach: 'var(--color-peach)',
  mint: 'var(--color-mint)',
  sky: 'var(--color-sky)',
  lemon: 'var(--color-lemon)',
  lilac: 'var(--color-lilac)',
};

function resolveColor(color: C2ShapeProps['color']): string {
  if (!color) return pastelVar.peach;
  if (color in pastelVar) return pastelVar[color as PastelColor];
  return color;
}

export default function C2Shape({ shape = 'circle', size = 200, color = 'peach', className = '', style }: C2ShapeProps) {
  const bg = resolveColor(color);
  if (shape === 'circle') {
    return (
      <div
        className={className}
        style={{ width: size, height: size, borderRadius: '50%', background: bg, ...style }}
      />
    );
  }
  if (shape === 'pill') {
    return (
      <div
        className={className}
        style={{ width: size, height: size * 0.4, borderRadius: 999, background: bg, ...style }}
      />
    );
  }
  return (
    <div
      className={className}
      style={{ width: size, height: size, borderRadius: 20, background: bg, ...style }}
    />
  );
}
